// extracted by mini-css-extract-plugin
export var description = "Panel-module--description--6db90";
export var label = "Panel-module--label--0d8b2";
export var panel = "Panel-module--panel--2f724";
export var title = "Panel-module--title--ca3d4";